import { omit } from 'lodash';

export const keysToOmit = [
  'validationMessage',
  'validationState',
  'setValue',
  'setTouched',
  'setUntouched'
];

export const omitFieldsetKeysForDOM = obj => omit(obj, keysToOmit);
